import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Megaphone } from 'lucide-react';
import { formatNewsDate, newsPosts } from '../data/news';

export const NewsStrip = () => {
  const latest = newsPosts[0];
  if (!latest) return null;
  return (
    <section className="hidden lg:block bg-[#0a1628] border-b border-white/10 pt-20" data-testid="home-news-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-orange-400 shrink-0">
          <Megaphone className="w-4 h-4" /> Latest News
        </span>
        <Link
          to={`/news/${latest.slug}`}
          data-testid="home-news-strip-link"
          className="group flex-1 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 min-w-0"
        >
          <span className="text-white font-medium text-sm sm:text-base leading-snug group-hover:text-orange-300 transition-colors">
            {latest.title}
          </span>
          <span className="text-slate-400 text-xs shrink-0">{formatNewsDate(latest.date)}</span>
          <span className="inline-flex items-center text-sm font-semibold text-orange-400 shrink-0 sm:ml-auto">
            Read more <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
          </span>
        </Link>
      </div>
    </section>
  );
};

export default NewsStrip;
